import React from "react";
import { Box, Grid, Card, CardContent, Typography } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import StoreIcon from "@mui/icons-material/Store";
import PeopleIcon from "@mui/icons-material/People";
import PaymentIcon from "@mui/icons-material/Payment";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

const menuItems = [
    {
        title: "Printer Settings",
        icon: <PrintIcon sx={{ fontSize: 40 }} />,
        link: "/printer-settings",
    },
    {
        title: "Resto Details",
        icon: <StoreIcon sx={{ fontSize: 40 }} />,
        link: "/resto-details",
    },
    {
        title: "Resto Users",
        icon: <PeopleIcon sx={{ fontSize: 40 }} />,
        link: "/resto-users",
    },
    {
        title: "Payment Modes",
        icon: <PaymentIcon sx={{ fontSize: 40 }} />,
        link: "/payment-modes",
    },
    {
        title: "Captain Assign",
        icon: <AssignmentIndIcon sx={{ fontSize: 40 }} />,
        link: "/captain-assign",
    },
];

function Settings() {
    return (

        <Box className=""
            sx={{
                p: 4,
            }}
        >

            <Card>
                <CardContent>
                    {/* FILTER CARD */}
                    <Typography variant="h5" fontWeight="bold" mb={2}>
                        Setting
                    </Typography>

                    <Grid className="row" spacing={3}>
                        {menuItems.map((item, index) => (
                            <Grid className="col-sm-2 mb-3" key={index}>
                                <Card
                                    onClick={() => (window.location.href = item.link)}
                                    sx={{
                                        borderRadius: "20px",
                                        cursor: "pointer",
                                        transition: "0.3s",
                                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                                        "&:hover": {
                                            transform: "translateY(-8px)",
                                            boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
                                        },
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            textAlign: "center",
                                            py: 3,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                backgroundColor: "#f0f4ff",
                                                width: 80,
                                                height: 80,
                                                borderRadius: "50%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                margin: "0 auto 20px",
                                                color: "#3f51b5",
                                            }}
                                        >
                                            {item.icon}
                                        </Box>

                                        <Typography fontWeight="600">
                                            {item.title}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

                </CardContent>
            </Card>
        </Box>
    );
}

export default Settings;